import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();

  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 12px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.3px',
    whiteSpace: 'nowrap',
    lineHeight: 1,
  };

  switch (status) {
    case 'ok':
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: '#ecfdf5',
            color: '#065f46',
            border: '1px solid #a7f3d0',
          }}
        >
          {t('In Stock')}
        </span>
      );

    case 'low':
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: '#fffbeb',
            color: '#92400e',
            border: '1px solid #fde68a',
          }}
        >
          {t('Low Stock')}
        </span>
      );

    case 'out':
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: '#fef2f2',
            color: '#991b1b',
            border: '1px solid #fecaca',
          }}
        >
          {t('Out of Stock')}
        </span>
      );

    default:
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: '#f3f4f6',
            color: '#374151',
            border: '1px solid #e5e7eb',
          }}
        >
          {status}
        </span>
      );
  }
};

StatusBadge.propTypes = {
  status: PropTypes.string,
};

StatusBadge.defaultProps = {
  status: '',
};

export default StatusBadge;